export enum ERoles {
  superadmin = 'superadmin',
  // admin = 'admin',
  // manager = 'manager',
  salesmanager = 'salesmanager',
  salesagent = 'salesagent',
  operationsadmin = 'operationsadmin',
  operationsmanager = 'operationsmanager',
  businesssalesagent = 'businesssalesagent',
  ispadmin = 'ispadmin',
  ispoperator = 'ispoperator',
  ispviewer = 'ispviewer',
  vnoadmin = 'vnoadmin',
  pmoadmin = 'pmoadmin',
  portalmanagement_admin = 'portalmanagement_admin',
  portalmanagement_user = 'portalmanagement_user'
}

export interface Permission {
  id: number;
  name: string;
  description?: string;
}

export interface Roles {
  id: number;
  name: ERoles;
  label?: string;
  description: string;
  permissions?: Permission[];
}
